import React from "react";
import { Link } from "components";
import ServiceLink from "./ServiceLink";
import YouTubeVideo from "./YouTubeVideo";
import VimeoVideo from "./VimeoVideo";
import MoreDetailsLink from "../MoreDetailsLink";

function getServiceLink(url) {
  const serviceMap = [
    {
      keyword: "discord.gg",
      service: "discord",
      title: "Discord",
    },
    {
      keyword: "github.com",
      service: "github",
      title: "GitHub",
    },
    {
      keyword: "linkedin.com",
      service: "linkedin",
      title: "LinkedIn",
    },
    {
      keyword: "youtube.com",
      service: "youtube",
      title: "YouTube",
    },
    {
      keyword: "tiktok.com",
      service: "tiktok",
      title: "TikTok",
    },
    {
      keyword: "instagram.com",
      service: "instagram",
      title: "Instagram",
    },
    {
      keyword: "twitter.com",
      service: "twitter",
      title: "X (Twitter)",
    },
    {
      keyword: "x.com",
      service: "twitter",
      title: "X (Twitter)",
    },
    {
      keyword: "bsky.app",
      service: "bsky",
      title: "Bluesky",
    },
    {
      keyword: "reddit.com",
      service: "reddit",
      title: "Reddit",
    },
    {
      keyword: "itch.io",
      service: "itch",
      title: "Itch.io",
    },
    {
      keyword: "steam.com",
      service: "steam",
      title: "Steam",
    },
    {
      keyword: "steampowered.com",
      service: "steam",
      title: "Steam",
    },
    {
      keyword: "onstove.com",
      service: "stove",
      title: "STOVE",
    },
    {
      keyword: "drive.google.com",
      service: "googleDrive",
      title: "Google Drive",
    },
    {
      keyword: "android:",
      service: "androidApk",
      title: "Android APK",
      processUrl: (url) => url.replace("android:", ""),
    },
    {
      keyword: "emscripten:",
      service: "emscripten",
      title: "Emscripten",
      processUrl: (url) => url.replace("emscripten:", ""),
    },
  ];

  // Find the matching service for the given URL
  for (let item of serviceMap) {
    if (url.indexOf(item.keyword) !== -1) {
      const processedUrl = item.processUrl ? item.processUrl(url) : url;
      return (
        <ServiceLink
          uri={processedUrl}
          service={item.service}
          title={item.title}
        />
      );
    }
  }
}

function getWidget(url) {
  // TODO: set general logic, not only YouTube

  if (url.indexOf("youtube.com") !== -1) {
    return <YouTubeVideo url={url} />;
  }

  if (url.indexOf("vimeo.com") !== -1) {
    return <VimeoVideo url={url} />;
  }
}

function hyperlink(node) {
  const uri = node.data.uri;

  if (uri.includes("icon:")) {
    const url = uri.replace("icon:", "");
    return getServiceLink(url);
  } else if (uri.indexOf("widget:") !== -1) {
    const url = uri.replace("widget:", "");
    return getWidget(url);
  }

  const text = node.content[0].value;

  if (text === "[More details]") {
    return <MoreDetailsLink path={uri} lang="en" />;
  }
  if (text === "[Детальніше]") {
    return <MoreDetailsLink path={uri} lang="ua" />;
  }
  if (text === "[Подробнее]") {
    return <MoreDetailsLink path={uri} lang="ru" />;
  }

  return (
    <Link to={uri} style={{ textDecoration: "underline", whiteSpace: "wrap" }}>
      {text}
    </Link>
  );
}

export default hyperlink;
